import { Component, OnInit, Input } from '@angular/core';
import { EmployeeInfoReport } from '../../../../models/reporting';

@Component({
  selector: 'app-appraisee-info-module',
  templateUrl: './appraisee-info-module.component.html',
  styles: []
})
export class AppraiseeInfoModuleComponent implements OnInit {
@Input() employeeInfoReport: EmployeeInfoReport;
@Input() endDate: string;
@Input() isIndividualBriefReport: boolean;

  constructor() { }

  ngOnInit() {
  }

}
